// Путь: D:\QR\QR-WEB\dashboard\src\components\User\CreateVoucher.jsx
// Версия: 6.0.0 - AI Generated Gifts (No Codes)
// Дата: 05.01.2026

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './CreateVoucher.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://qr-money.onrender.com';

const AMOUNTS = [5, 10, 25, 50, 100];

const AI_STYLES = [
  { id: 'gift', title: 'Подарок', emoji: '🎁', desc: 'Универсальный', color: '#667eea' },
  { id: 'festive', title: 'Праздник', emoji: '🎉', desc: 'Яркий', color: '#f59e0b' },
  { id: 'premium', title: 'Премиум', emoji: '👑', desc: 'Элегантный', color: '#1a1a2e' },
  { id: 'tech', title: 'Технологии', emoji: '🚀', desc: 'Футуристичный', color: '#06b6d4' },
  { id: 'romantic', title: 'Романтика', emoji: '💝', desc: 'С любовью', color: '#ec4899' },
  { id: 'newyear', title: 'Новый год', emoji: '🎄', desc: 'Праздничный', color: '#22c55e' }
];

const TTL_OPTIONS = [
  { value: '1', label: '1 час' },
  { value: '12', label: '12 часов' },
  { value: '24', label: '24 часа' },
  { value: '72', label: '3 дня' },
  { value: '168', label: '7 дней' }
];

const CreateVoucher = () => {
  const [amount, setAmount] = useState(null);
  const [ttlHours, setTtlHours] = useState('24');
  const [selectedStyle, setSelectedStyle] = useState(AI_STYLES[0]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(null);
  const [balance, setBalance] = useState(0);
  const [copied, setCopied] = useState(false);

  const token = localStorage.getItem('authToken');
  const userId = localStorage.getItem('userId');

  useEffect(() => {
    fetchBalance();
  }, []);

  const fetchBalance = async () => {
    try {
      const res = await axios.get(API_URL + '/api/balance/' + userId, {
        headers: { Authorization: 'Bearer ' + token }
      });
      if (res.data.success) {
        const bal = res.data.data;
        setBalance(parseFloat(bal.available_amount || bal.available || bal.amount || 0));
      }
    } catch (err) {
      console.error('Balance error:', err);
    }
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(null);
    setLoading(true);

    if (!amount) {
      setError('Выберите сумму подарка');
      setLoading(false);
      return;
    }

    if (amount > balance) {
      setError('Недостаточно средств');
      setLoading(false);
      return;
    }

    try {
      const res = await axios.post(API_URL + '/api/vouchers/create-ai', {
        amount: amount,
        ttlHours: parseInt(ttlHours),
        aiStyle: selectedStyle.id
      }, {
        headers: { Authorization: 'Bearer ' + token }
      });

      if (res.data.success) {
        setSuccess({
          ...res.data.data,
          styleTitle: selectedStyle.title,
          styleEmoji: selectedStyle.emoji
        });
        setAmount(null);
        fetchBalance();
      } else {
        setError(res.data.error || 'Ошибка создания подарка');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Ошибка сервера');
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setSuccess(null);
    setSelectedStyle(AI_STYLES[0]);
    setCopied(false);
  };

  // Скачать картинку с красивым названием
  const downloadImage = async () => {
    if (!success.image_url) return;
    
    try {
      const response = await fetch(success.image_url);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      
      // Генерируем красивое название
	  
      link.download = `DARY_Gift.png`;
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      // Fallback
      const link = document.createElement('a');
      link.href = success.image_url;
      link.download = `DARY_Gift_${Date.now()}.png`;
      link.click();
    }
  };

  // Копировать картинку в буфер обмена
  const copyImageToClipboard = async () => {
    if (!success.image_url) return;
    
    try {
      const response = await fetch(success.image_url);
      const blob = await response.blob();
      await navigator.clipboard.write([
        new ClipboardItem({ 'image/png': blob })
      ]);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Copy failed:', err);
      // Fallback - копируем ссылку
      navigator.clipboard.writeText(success.image_url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  // Поделиться через Web Share API
  const shareGift = async () => {
    if (!success.image_url) return;

    // Проверяем поддержку Web Share API
    if (navigator.share) {
      try {
        const response = await fetch(success.image_url);
        const blob = await response.blob();
        const file = new File([blob], 'DARY_Gift.png', { type: 'image/png' });

        await navigator.share({
          title: '🎁 Подарок для тебя!',
          text: `Получи ${success.amount} DAR от DARY! Открой картинку на dary.one`,
          files: [file]
        });
      } catch (err) {
        // Если не удалось поделиться файлом, делимся текстом
        try {
          await navigator.share({
            title: '🎁 Подарок для тебя!',
            text: `Получи подарок от DARY! Открой на dary.one`,
            url: 'https://dary.one'
          });
        } catch (e) {
          console.log('Share cancelled');
        }
      }
    } else {
      // Fallback - копируем ссылку
      copyImageToClipboard();
    }
  };

  // Форматирование TTL для отображения
  const getExpiryText = () => {
    const hours = parseInt(ttlHours);
    if (hours === 1) return '1 час';
    if (hours < 24) return `${hours} часов`;
    if (hours === 24) return '1 день';
    if (hours === 72) return '3 дня';
    if (hours === 168) return '7 дней';
    return `${Math.floor(hours / 24)} дней`;
  };

  return (
    <div className="create-voucher-container">
      {success ? (
        <div className="success-section">
          <div className="success-header">
            <span className="success-icon">✅</span>
            <h2>AI Подарок создан!</h2>
          </div>
          <p className="success-subtitle">
            Отправьте картинку получателю — подарок зашифрован внутри
          </p>
          
          {success.image_url ? (
            <div className="ai-gift-preview">
              <img src={success.image_url} alt="AI Gift" />
              <div className="gift-badge">
                <span>{success.styleEmoji}</span>
                <span>{parseFloat(success.amount).toFixed(0)} DAR</span>
              </div>
            </div>
          ) : (
            <div className="ai-gift-placeholder-large">
              <span>{success.styleEmoji}</span>
              <p>{success.amount} DAR</p>
            </div>
          )}

          <div className="gift-details">
            <div className="detail-row">
              <span className="detail-label">Сумма</span>
              <span className="detail-value amount">{parseFloat(success.amount).toFixed(2)} DAR</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Стиль</span>
              <span className="detail-value">{success.styleEmoji} {success.styleTitle}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Действует</span>
              <span className="detail-value">{getExpiryText()}</span>
            </div>
          </div>

          <div className="action-buttons">
            <button onClick={downloadImage} className="btn-primary">
              📥 Скачать картинку
            </button>
            <button onClick={copyImageToClipboard} className="btn-secondary">
              {copied ? '✓ Скопировано!' : '📋 Копировать'}
            </button>
            <button onClick={shareGift} className="btn-secondary">
              📤 Поделиться
            </button>
          </div>

          <div className="hint-box">
            <span className="hint-icon">💡</span>
            <p>Получатель загружает картинку на <strong>dary.one</strong> и автоматически получает средства</p>
          </div>

          <button onClick={resetForm} className="btn-create-another">
            ➕ Создать ещё подарок
          </button>
        </div>
      ) : (
        <form onSubmit={handleCreate} className="voucher-form">
          <div className="form-header">
            <h2>🎨 Создать AI подарок</h2>
            <span className="balance-badge">
              Баланс: <strong>{balance.toFixed(2)} DAR</strong>
            </span>
          </div>

          {error && <div className="error-message">{error}</div>}

          {/* СУММА */}
          <div className="form-group">
            <label>Сумма подарка (DAR)</label>
            <div className="amount-buttons">
              {AMOUNTS.map(val => (
                <button 
                  key={val} 
                  type="button" 
                  className={'amount-btn ' + (amount === val ? 'active' : '')}
                  onClick={() => setAmount(val)}
                  disabled={val > balance}
                >
                  {val}
                </button>
              ))}
            </div>
          </div>

          {/* СРОК */}
          <div className="form-group">
            <label>Срок действия</label>
            <div className="ttl-buttons">
              {TTL_OPTIONS.map(opt => (
                <button 
                  key={opt.value} 
                  type="button" 
                  className={'ttl-btn ' + (ttlHours === opt.value ? 'active' : '')}
                  onClick={() => setTtlHours(opt.value)}
                >
                  {opt.label}
                </button>
              ))}
            </div>
          </div>

          {/* AI СТИЛЬ */}
          <div className="form-group">
            <label>Стиль AI картинки</label>
            <div className="styles-grid">
              {AI_STYLES.map(style => (
                <div 
                  key={style.id}
                  className={'style-card ' + (selectedStyle.id === style.id ? 'selected' : '')}
                  onClick={() => setSelectedStyle(style)}
                  style={selectedStyle.id === style.id ? {'--accent': style.color} : {}}
                >
                  <span className="style-emoji">{style.emoji}</span>
                  <span className="style-title">{style.title}</span>
                  <span className="style-desc">{style.desc}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Превью выбора */}
          {amount && (
            <div className="selection-preview">
              <span>{selectedStyle.emoji}</span>
              <span>{amount} DAR</span>
              <span>•</span>
              <span>{getExpiryText()}</span>
            </div>
          )}

          <button type="submit" disabled={loading || !amount} className="btn-create">
            {loading ? (
              <>
                <span className="spinner"></span>
                Генерация AI картинки...
              </>
            ) : (
              '🎁 Создать AI подарок'
            )}
          </button>
          
          {loading && (
            <p className="generation-hint">⏱️ Обычно занимает 15-30 секунд</p>
          )}
        </form>
      )}
    </div>
  );
};

export default CreateVoucher;